/**
 * Code generated by "npm run build-assets"
 * Figma URL: https://nda.ya.ru/t/W2N0zVJ06Uek38
 */

import {ImageAssetMeta, SrcSet} from '@yandex-delivery/assets'

import img1x from './courier_new_year@1x.png'
import img2x from './courier_new_year@2x.png'
import img3x from './courier_new_year@3x.png'

export const courierNewYear: ImageAssetMeta = {
  width: 56,
  height: 73,
  srcSet: new SrcSet(img1x, img2x, img3x),
}
